export default "__VITE_ASSET__7265e73e__$_?nuxt_component=async__"